import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "alert-overflow",
    style: `width: ${_vm.drawWidth}; height: ${_vm.drawSize};`
  }, _vm._l(_vm.lclAlertTable, function (item, i) {
    return _c(VChip, {
      key: i,
      staticClass: "ma-1",
      attrs: {
        "color": "#ff1744",
        "small": "",
        "outlined": ""
      }
    }, [_c(VAvatar, {
      attrs: {
        "left": ""
      }
    }, [_c(VIcon, {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fal fa-bell-on")])], 1), _vm._v("\n    " + _vm._s(item.dtwin) + "\n  ")], 1);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };